import { unsafeAsDraft } from '@ipfabric/utils/immer/unsafeAsDraft';
import type { GlobalStateCommandFactory } from 'components/GlobalState/GlobalStateModel';

interface SetContentAfterContainerCommand {
  contentAfterContainer: HTMLElement | null;
}

export const setContentAfterContainer: GlobalStateCommandFactory<
  SetContentAfterContainerCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    draft.contentAfterContainer = unsafeAsDraft(command.contentAfterContainer);
  });
};
